/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionplacecardtitle3Inputs */

const en_actionplacecardtitle3 = /** @type {(inputs: Actionplacecardtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_actionplacecardtitle3 = /** @type {(inputs: Actionplacecardtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Actionplacecardtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionplacecardtitle3 = /** @type {((inputs?: Actionplacecardtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionplacecardtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionplacecardtitle3(inputs)
	return de_actionplacecardtitle3(inputs)
});
export { actionplacecardtitle3 as "actionPlaceCardTitle" }